import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-950px modal-fullscreen-lg-down" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_10 = ["name", "id"]
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade modal-lg-fullscreen-fix",
    tabindex: "-1",
    id: _ctx.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t("DeclaracionResponsableModalTitulo")), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "mb-5 textoJustificado",
            innerHTML: _ctx.html
          }, null, 8, _hoisted_8),
          _renderSlot(_ctx.$slots, "header"),
          _renderSlot(_ctx.$slots, "body"),
          _renderSlot(_ctx.$slots, "footer"),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              name: _ctx.name,
              class: "form-check-input form-control form-control-solid",
              type: "checkbox",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              id: _ctx.id + '-check'
            }, null, 8, _hoisted_10), [
              [_vModelCheckbox, _ctx.value]
            ]),
            _createElementVNode("label", {
              class: "form-check-label required",
              for: _ctx.id + '-check'
            }, _toDisplayString(_ctx.$t("DeclaracionResponsableModalCheck")), 9, _hoisted_11)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t("DeclaracionResponsableModalButton")), 1)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}